<template>
    <b-card no-body v-if="settings[category][position]">
        <template v-if="toggable">
            <b-card-header class="p-1">
                <b-button block variant="default" @click="visible = !visible">
                    {{ trans_p('labels', 'btn.open', { txt: settings[category][position + 'Collapse'], }) }}
                </b-button>
            </b-card-header>
            <b-collapse v-model="visible">
                <b-card-body>
                    <div v-html="settings[category][position]"></div>
                    <div class="text-right">
                        <b-link @click="visible = false">{{ trans_p('labels', 'btn.close', { txt: settings[category][position + 'Collapse'], }) }}</b-link>
                    </div>
                </b-card-body>
            </b-collapse>
        </template>
        <template v-else>
            <b-card-body>
                <div v-html="settings[category][position]"></div>
            </b-card-body>
        </template>
    </b-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        category: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
        position: {
            type: String,
            required: true,
            default() {
                return ''
            },
        },
        settings: {
            type: Object,
            required: true,
            default() {
                return {
                }
            },
        },
    },
    data() {
        return {
            visible: false,
        }
    },
    computed: {
        ...mapGetters([
            'auth_id',
            'auth_level',
            'auth_check',
            'trans',
            'trans_p',
        ]),
        toggable() {
            if (!this.settings) {
                return false
            }
            if (!this.settings[this.category]) {
                return false
            }
            if (!this.settings[this.category][this.position + 'Collapse']) {
                return false
            }
            return true
        },
    },
    async mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped>
</style>

